import { Skeleton } from '@/components/ui/skeleton';
import InsightCard from './InsightCard';

interface InsightCardListProps {
  data?: Array<{ title: string; body: string }>;
  isLoading?: boolean;
  showNumbers?: boolean;
  voiceQuotes?: Array<{ conversation_id: string; message_id?: string }>;
}

function InsightCardList({ data, isLoading = false, showNumbers = true, voiceQuotes }: InsightCardListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-lg border border-neutral-100 bg-neutral-50/50 p-4">
            <div className="flex gap-3">
              <Skeleton className="h-6 w-6 rounded-full shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-48 rounded-sm" />
                <Skeleton className="h-4 w-full rounded-sm" />
                <Skeleton className="h-4 w-[80%] rounded-sm" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-3">
      {data.map((item, idx) => (
        <InsightCard
          key={idx}
          title={item.title}
          body={item.body}
          index={showNumbers ? idx + 1 : undefined}
          voiceQuotes={voiceQuotes}
        />
      ))}
    </div>
  );
}

export default InsightCardList;
